/* Avioré cart drawer: 10-minuten timer en upsell (toevoegen + slider) */
(function () {
  if (window.__aviorCartLoaded) return;
  window.__aviorCartLoaded = true;

  var KEY = 'aviore_cart_timer_end';
  var DURATION = 10 * 60 * 1000; // 10 minuten
  var STALE_AFTER = 6 * 60 * 60 * 1000; // na 6 uur opnieuw beginnen

  function readEnd() {
    try {
      return parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeEnd(value) {
    try {
      if (value) localStorage.setItem(KEY, String(value));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var drawer = document.querySelector('cart-drawer');
    var timers = document.querySelectorAll('[data-aviore-timer]');
    var now = Date.now();
    var end = readEnd();

    // Lege winkelmand: timer opnieuw laten beginnen bij het volgende artikel
    if (drawer && drawer.classList.contains('is-empty')) {
      if (end) writeEnd(0);
      return;
    }

    if (end && now - end > STALE_AFTER) {
      writeEnd(0);
      end = 0;
    }

    // De timer start zodra de slider geopend wordt met artikelen erin
    var drawerOpen = drawer && drawer.classList.contains('active');
    if (!end && drawerOpen && timers.length) {
      end = now + DURATION;
      writeEnd(end);
    }

    timers.forEach(function (el) {
      var display = el.querySelector('[data-aviore-timer-display]');
      var label = el.querySelector('[data-aviore-timer-label]');
      if (!display || !label) return;

      if (!end) {
        display.textContent = '10:00';
        el.classList.remove('is-expired', 'is-urgent');
        return;
      }

      var left = end - now;
      if (left <= 0) {
        el.classList.add('is-expired');
        el.classList.remove('is-urgent');
        label.textContent = 'Je artikelen staan nog voor je klaar in je winkelmand';
        return;
      }

      el.classList.remove('is-expired');
      el.classList.toggle('is-urgent', left <= 60000);
      label.textContent = 'Rond je bestelling af binnen';
      var seconds = Math.ceil(left / 1000);
      display.textContent = pad(Math.floor(seconds / 60)) + ':' + pad(seconds % 60);
    });
  }

  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);

  function addUpsell(button) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || button.disabled) return;

    var originalLabel = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Bezig...';

    var body = new FormData();
    body.append('id', button.getAttribute('data-variant-id'));
    body.append('quantity', 1);
    body.append(
      'sections',
      drawer
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',')
    );
    body.append('sections_url', window.location.pathname);

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.textContent = 'Niet beschikbaar';
          return;
        }
        drawer.renderContents(state);
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
      });
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-aviore-upsell-add]');
    if (addButton) {
      event.preventDefault();
      addUpsell(addButton);
      return;
    }

    var arrow = event.target.closest('[data-aviore-upsell-nav]');
    if (arrow) {
      var wrapper = arrow.closest('.aviore-upsell');
      var track = wrapper && wrapper.querySelector('[data-aviore-upsell-track]');
      if (!track) return;
      var direction = arrow.getAttribute('data-aviore-upsell-nav') === 'next' ? 1 : -1;
      track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });
})();